import { useCallback } from 'react';
import { PackageSessionResponse } from '~/types/api';

export type FormattedRoomType = {
  service_code: string;
  name: string;
  pax: number;
};

export default function useFormattedRoomTypes() {
  const formatRoomTypes = useCallback((originalRoomTypes?: PackageSessionResponse['room_types']) => {
    if (!originalRoomTypes) {
      return [];
    }

    const roomTypes: FormattedRoomType[] = [];

    originalRoomTypes?.forEach((roomType) => {
      roomTypes.push({
        service_code: roomType.service_code,
        name: roomType.name,
        pax: roomType.pax,
      });
    });

    return roomTypes;
  }, []);

  return {
    formatRoomTypes,
  };
}
